<template>
	<div class="transferencia-fin-page" style="position: relative;">
		<div class="transferencia-fin-header">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>{{ espectaculo.tipoNombre }}</span>
					</div>
				</div>
				<div class="header-row" v-if="espectaculo.requiereInstituciones">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<img :src="espectaculo.institucionLocalEscudo" :alt="espectaculo.institucionLocalNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionLocalNombre }}</span>
							<span class="vs">vs</span>
						</div>
						<div class="header-equipo header-equipo-visitante">
							<img :src="espectaculo.institucionVisitanteEscudo" :alt="espectaculo.institucionVisitanteNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionVisitanteNombre }}</span>
						</div>
					</div>
				</div>
				<div class="header-row" v-else>
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<span>{{ espectaculo.nombre }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="transferencia-fin-main">
			<div class="container">
				<div class="transferencia-fin-left">

					<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
						<circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
						<path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
					</svg>
					<h1>¡Transferencia realizada con éxito!</h1>
					<p>Se realizó con éxito la transferencia de butaca. Puedes ver tu ticket en la sección <span class="italic">'Mis Entradas'</span>.</p>
					<router-link :to="{ name: 'mis-entradas' }" class="btn">Ver mis entradas</router-link>
					<div class="noticias-content" v-if="SDTNoticias.length">
						<h3>Quizás te pueda interesar</h3>
						<div class="noticias">
							<div class="noticia" v-for="noticia in SDTNoticias" :key="noticia.NoticiaId">
								<a :href="noticia.NoticiaLink" v-if="noticia.NoticiaTipo !== 'G'">
									<div class="noticia-img" :style="{ 'background-image': 'url(' + noticia.NoticiaImagen + ')' }"></div>
									<div class="noticia-main">
										<span class="noticia-title">{{ noticia.NoticiaTitulo }}</span>
										<div class="noticia-bottom" v-if="noticia.NoticiaFecha !== '0000-00-00' || noticia.NoticiaCategoria">
											<span class="noticia-categoria" v-if="noticia.NoticiaCategoria">{{ noticia.NoticiaCategoria }}  | </span>
											<span class="noticia-fecha" v-if="noticia.NoticiaFecha !== '0000-00-00'">{{ noticia.NoticiaFecha }}</span>
										</div>
									</div>
								</a>
								<a :href="noticia.NoticiaLink" class="galeria" v-else>
									<div class="noticia-img-galeria" :style="{ 'background-image': 'url(' + noticia.NoticiaImagen + ')' }"></div>
									<div class="noticia-main-galeria">
										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><polygon points="0 0 24 0 24 24 0 24"></polygon><path fill="#161616" d="M20.5,8.0305 L20.5,20.4971667 L3.5,20.4971667 L3.5,8.0305 L20.5,8.0305 Z M17.6666667,5.7695 L17.6666667,6.90283333 L6.33333333,6.90283333 L6.33333333,5.7695 L17.6666667,5.7695 Z M14.8333333,3.50283333 L14.8333333,4.63616667 L9.16666667,4.63616667 L9.16666667,3.50283333 L14.8333333,3.50283333 Z"></path></g></svg>
										<span class="noticia-title">{{ noticia.NoticiaTitulo }}</span>
										<div class="noticia-bottom" v-if="noticia.NoticiaFecha !== '0000-00-00' || noticia.NoticiaCategoria">
											<span class="noticia-categoria" v-if="noticia.NoticiaCategoria">{{ noticia.NoticiaCategoria }}  | </span>
											<span class="noticia-fecha" v-if="noticia.NoticiaFecha !== '0000-00-00'">{{ noticia.NoticiaFecha }}</span>
										</div>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="transferencia-fin-right">
					<p>Información del espectáculo</p>
					<div class="transferencia-fin-right-content">
						<div class="competencia" v-if="espectaculo.mostrarCompetencia">
							<div class="competencia-info">
								<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
								<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
							</div>
							<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre" v-if="espectaculo.competenciaLogo">
						</div>
						<div class="fecha" v-if="espectaculo.mostrarFecha">
							<span class="fecha-title">Fecha</span>
							<div class="fecha-content">
								<div class="fecha-texto">
									<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
									<p>{{ espectaculo.fechaEscrita }}</p>
								</div>
								<div class="fecha-hora">
									{{ espectaculo.hora }}
								</div>
							</div>
						</div>
						<div class="lugar" v-if="espectaculo.mostrarEscenario">
							<span class="lugar-title">Lugar</span>
							<div class="lugar-content">
								<div class="lugar-content-left">
									<div class="lugar-info">
										<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
										<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
									</div>
									<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre" v-if="espectaculo.escenarioLogo">
								</div>
								<div class="ver-mapa" content="Ver ubicación" v-tippy="{ placement : 'bottom'}">
									<a :href="espectaculo.escenarioMapaURL" target="_blank"><map-icon></map-icon></a>
								</div>
							</div>
						</div>
						<div class="descripcion">
							<span class="descripcion-title">Descripción</span>
							<!-- <span class="descripcion-content">{{ espectaculo.descripcion }}</span> -->
							<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { MapIcon } from 'vue-feather-icons'

	export default {
		props: ['isOk'],
		data() {
			return {
				usuarioId: localStorage.getItem('usuario_id'),
				espectaculo: {
					id: null,
					nombre: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					fechaDiaSemanaEscrito: '',
					hora: '',
					escenarioNombre: '',
					escenarioLogo: '',
					escenarioSVG: '',
					escenarioMapaURL: '',
					escenarioDireccion: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					descripcion: '',
					mostrarCompetencia: false,
					mostrarFecha: false,
					mostrarEscenario: false
				},
				SDTNoticias: []
			}
		},
		components: {
			MapIcon
		},
		async mounted() {
			if(this.isOk !== 'isok'){
				this.$router.push({ name: 'home' })
			}

			await this.obtenerEspectaculo();
			await this.obtenerNoticias();
		},
		methods: {
			async obtenerEspectaculo(){
				// Obtengo espectáculo
				try {
					let response = await axios.post('/WSEspectaculo', { EspectaculoId : parseInt(this.$route.params.espectaculoId) });
				
					if(response.data.ErrorCod === 0){
						var data = response.data.SDTEspectaculo;

						this.espectaculo.id = parseInt(data.EspectaculoId);
						this.espectaculo.nombre = data.EspectaculoNombre;
						this.espectaculo.tipoId = parseInt(data.EspectaculoTipoId);
						this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculo.tipoColor = data.EspectaculoTipoColor;
						this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
						this.espectaculo.hora = data.EspectaculoHora;
						this.espectaculo.escenarioNombre = data.EscenarioNombre;
						this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
						this.espectaculo.escenarioDireccion = data.EscenarioDireccion;
						this.espectaculo.competenciaNombre = data.CompetenciaNombre;
						this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculo.descripcion = data.EspectaculoDescripcion;

						this.espectaculo.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia;
						this.espectaculo.mostrarFecha = data.EspectaculoFrontMostrarFecha;
						this.espectaculo.mostrarEscenario = data.EspectaculoFrontMostrarEscenario;
					} else {
						// Redirigir a 404 (no se encontró espectáculo)
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async obtenerNoticias(){
				try {
					let response = await axios.post('/WSNoticias', {});

					if(response.data.ErrorCod === 0){
						this.SDTNoticias = response.data.SDTNoticias;
					} else {
						this.SDTNoticias = [];
					}
				} catch (error) {
					console.log('Ocurrió un error al intentar obtener las noticias');
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.transferencia-fin-page{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.transferencia-fin-header{
			padding-top: 76px;
			width: 100%;
			position: relative;
			height: 310px;
			background: url('../../assets/sports-player-background.jpg');
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			@include flex(column, flex-start, center);

			.container{
				height: 100%;
				margin: 0;
				width: 100%;
				@include flex(column, flex-end, center);
				max-width: 1166px;
				padding: 0px 16px;
				z-index: 1;
				padding-bottom: 10px;
				@include flex(column, flex-end, flex-start);
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: var(--color-white);
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							line-height: 1.1em;
							color: var(--color-white);
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
						}

						&.header-equipo-local{
							span{
								font-size: 32px;

								&.vs{
									font-family: var(--font-family-poppins);
									line-height: 1em;
									color: var(--color-blue-light);
									font-size: 24px;
									margin-left: 10px;
									margin-top: 6px;
									font-weight: var(--font-weight-bold);
								}
							}

							.header-escudo{
								height: 39px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{
							margin-top: 5px;
							
							span{
								font-size: 30px;
							}

							.header-escudo{
								height: 34px;
								width: auto;
								margin-right: 10px;
								margin-left: 3px;
							}
						}
					}
				}
			}
		}

		.transferencia-fin-main{
			width: 100%;
			position: relative;
			margin: 64px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.transferencia-fin-right{
					top: 102px;
					position: sticky;
					margin-top: 0px;
					width: calc(30% - 16px);

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
						margin-bottom: 18px;
					}

					.transferencia-fin-right-content{
						border-radius: 8px;
						border: 1px solid #d3d3dc;
						@include flex(column, flex-start, flex-start);

						.competencia{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(row, space-between, center);

							.competencia-info{
								@include flex(column, center, flex-start);

								span.competencia-nombre{
									margin: 0;
									font-size: 13px;
									line-height: 20px;
									margin-bottom: 0px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								span.competencia-instancia{
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 15px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}

							img{
								height: 32px;
								width: auto;
								margin-left: 15px;
							}
						}

						.fecha{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.fecha-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.fecha-content{
								width: 100%;
								@include flex(row, space-between, center);

								.fecha-texto{
									@include flex(column, center, flex-start);

									p{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 20px;
										margin: 0;
									}
								}

								.fecha-hora{
									height: 100%;
									margin-left: 14px;
									border-left: 1px solid #d3d3dc;
									padding: 10px 0 10px 14px;
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 21px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}
						}

						.lugar{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.lugar-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.lugar-content{
								@include flex(row, space-between, center);
								width: 100%;

								.lugar-content-left{
									@include flex(row, flex-start, center);

									.lugar-info{
										padding-right: 12px;
										// border-right: 1px solid #d3d3dc;
										@include flex(column, center, flex-start);

										span.lugar-escenario{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 15px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 20px;
										}

										span.lugar-direccion{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 13px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 18px;
										}
									}

									img{
										width: 28px;
										height: auto;
										margin-left: 12px;
									}
								}

								.ver-mapa{
									@include flex(column, center, center);
									margin-left: 12px;

									a{
										background-color: transparent;
										border: 1px solid var(--color-blue-darker);
										padding: 6px;
										text-decoration: none;
										@include flex(row, center, center);
										transition: all .2s;
										border-radius: 99px;

										svg{
											width: 15px;
											height: auto;
											transition: all .2s;
											color: var(--color-blue-darker);
										}

										&:hover{
											background-color: var(--color-blue-darker);

											svg{
												color: var(--color-white);
											}
										}
									}
								}
							}
						}

						.descripcion{
							border-radius: 0px;
							border: none;
							padding: 20px;
							width: 100%;
							@include flex(column, flex-start, flex-start);
							
							.descripcion-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.descripcion-content{
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}
					}
				}

				.transferencia-fin-left{
					width: calc(70% - 16px);
					background-color: var(--color-white);
					padding: 0px;
					@include flex(column, center, center);

					h1{
						margin: 0;
						margin-top: 0;
						color: var(--color-red);
						font-weight: initial;
						font-size: 42px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
						text-align: center;
					}

					p{
						margin: 0;
						font-size: 16px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						// font-weight: bold;
						color: var(--color-dark);
						text-align: center;
						margin-top: 3px;
					}

					.italic{
						font-style: italic;
					}

					a.btn{
						width: 100%;
						@include flex(row, center, center);
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						font-weight: var(--font-weight-bold);
						position: relative;
						cursor: pointer;
						max-width: 260px;
						background-color: var(--color-red);
						color: var(--color-white);
						-webkit-transition: background-color .2s ease;
						transition: background-color .2s ease;
						-webkit-letter-spacing: 1px;
						-moz-letter-spacing: 1px;
						-ms-letter-spacing: 1px;
						letter-spacing: 1px;
						padding: 12px 24px;
						font-size: 14px;
						line-height: 20px;
						-webkit-font-smoothing: antialiased;
						-moz-osx-font-smoothing: grayscale;
						outline-color: transparent;
						outline: none;
						box-shadow: none;
						border: 0;
						margin: 0;
						margin-top: 30px;
						margin-bottom: 20px;

						&:hover{
							background-color: var(--color-blue-dark);
							text-decoration: none;
						}
					}

					.checkmark__circle {
						stroke-dasharray: 166;
						stroke-dashoffset: 166;
						stroke-width: 2;
						stroke-miterlimit: 10;
						stroke: #7ac142;
						fill: none;
						animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
					}

					.checkmark {
						width: 56px;
						height: 56px;
						border-radius: 50%;
						display: block;
						stroke-width: 2;
						stroke: #fff;
						stroke-miterlimit: 10;
						margin: 0 auto;
						margin-bottom: 20px;
						box-shadow: inset 0px 0px 0px #7ac142;
						animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
					}

					.checkmark__check {
						transform-origin: 50% 50%;
						stroke-dasharray: 48;
						stroke-dashoffset: 48;
						animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
					}

					@keyframes stroke {
						100% {
							stroke-dashoffset: 0;
						}
					}
					@keyframes scale {
						0%, 100% {
							transform: none;
						}
						50% {
							transform: scale3d(1.1, 1.1, 1);
						}
					}
					@keyframes fill {
						100% {
							box-shadow: inset 0px 0px 0px 30px #7ac142;
						}
					}

					.noticias-content{
						width: 100%;
						margin-top: 50px;
						@include flex(column, flex-start, flex-start);

						h3{
							text-transform: uppercase;
							color: var(--color-blue-dark);
							font-family: var(--font-family-kapra-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							font-size: 32px;
							line-height: 32px;
							margin-bottom: 0;
							font-weight: var(--font-weight-bold);
						}

						.noticias{
							width: 100%;
							margin: 30px 0 20px 0;
							display: grid;
							grid-template-columns: repeat(2, 1fr);
							// grid-auto-rows: 1fr;
							grid-column-gap: 30px;
							grid-row-gap: 30px;
							
							.noticia{
								padding: 0px;
								position: relative;
								@include flex(column, flex-start, flex-start);
								min-height: 380px;

								a{
									width: 100%;
									height: 100%;
									@include flex(column, space-between, flex-start);
									text-decoration: none;
									box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
									-webkit-box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
									// aspect-ratio: 3 / 4;

									.noticia-img{
										width: 100%;
										height: 200px;
										background-repeat: no-repeat;
										background-size: cover;
										background-position: center;
									}

									.noticia-main{
										width: 100%;
										background-color: var(--color-white);
										padding: 20px 24px 24px;
										height: 40%;
										min-height: 180px;
										@include flex(column, space-between, flex-start);

										.noticia-title{
											width: 100%;
											font-family: var(--font-family-fira);
											font-size: 18px;
											line-height: 22px;
											font-weight: var(--font-weight-bold);
											color: var(--color-dark);
											margin-bottom: 24px;
											overflow: hidden;
											text-overflow: ellipsis;
										}

										.noticia-bottom{
											width: 100%;
											@include flex(row, flex-start, center);

											.noticia-categoria{
												font-family: var(--font-family-poppins);
												font-size: 13px;
												font-weight: bold;
												line-height: 20px;
												text-transform: uppercase;
												color: var(--color-red);
												margin-right: 4px;
											}

											.noticia-fecha{
												font-family: var(--font-family-poppins);
												font-size: 13px;
												line-height: 20px;
												text-transform: uppercase;
												color: var(--color-grey);
											}
										}
									}

									&.galeria{
										position: relative;
										@include flex(column, flex-end, flex-start);

										// &:before{
										// 	content: '';
										// 	width: 100%;
										// 	height: 60%;
										// 	left: 0;
										// 	bottom: 0;
										// 	background: linear-gradient(180deg,rgba(0,70,173,0) 0%,var(--color-blue) 100%);
										// 	z-index: 2;
										// 	position: absolute;
										// }

										.noticia-img-galeria{
											width: 100%;
											height: 100%;
											background-repeat: no-repeat;
											background-size: cover;
											background-position: center;
											position: absolute;
											top: 0;
											left: 0;
											z-index: 1;
										}

										.noticia-main-galeria{
											width: 100%;
											padding: 20px 24px 24px;
											@include flex(column, flex-end, flex-start);
											z-index: 3;

											svg{
												width: 32px;
												height: 32px;

												path{
													fill: var(--color-white);
												}
											}

											.noticia-title{
												width: 100%;
												font-family: var(--font-family-fira);
												font-size: 18px;
												line-height: 22px;
												font-weight: var(--font-weight-bold);
												color: var(--color-white);
												-webkit-line-clamp: 4;
												margin: 16px 0;
												overflow: hidden;
												text-overflow: ellipsis;
											}

											.noticia-bottom{
												width: 100%;
												@include flex(row, flex-start, center);

												.noticia-categoria{
													font-family: var(--font-family-poppins);
													font-size: 13px;
													font-weight: bold;
													line-height: 20px;
													text-transform: uppercase;
													color: var(--color-blue-light);
													margin-right: 4px;
												}

												.noticia-fecha{
													font-family: var(--font-family-poppins);
													font-size: 13px;
													line-height: 20px;
													text-transform: uppercase;
													color: var(--color-white);
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}



	/* Responsive */
	@media screen and(max-width: 910px){
		.transferencia-fin-page{
			.transferencia-fin-header{
				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 24px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 32px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							font-size: 18px;
							margin-left: 8px;
							margin-top: 3px;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 28px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}

			.transferencia-fin-main{
				margin: 30px 0;
				.container{
					@include flex(column, flex-start, flex-start);

					.transferencia-fin-left{
						width: 100%;
					}

					.transferencia-fin-right{
						margin-top: 30px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 690px){
		.transferencia-fin-page .transferencia-fin-main .container .transferencia-fin-left .noticias-content{
			margin-top: 20px;
		}

		.transferencia-fin-page .transferencia-fin-main .container .transferencia-fin-left .noticias-content .noticias{
			grid-template-columns: repeat(1, 1fr);
		}

		.transferencia-fin-page .transferencia-fin-main .container .transferencia-fin-left .noticias-content .noticias .noticia a .noticia-main{
			min-height: auto;
		}
	}

	@media screen and(max-width: 490px){
		.transferencia-fin-page{
			.transferencia-fin-header{
				height: 250px;

				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 20px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 30px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							display: none;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 26px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}
		}
	}
</style>